/* eslint-disable */

import PARSE from "html-react-parser";
import React, { useCallback, useEffect, useState } from "react";
import { VscArrowRight } from "react-icons/vsc";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import GlobalApi from "../../context/api/GlobalApi";
import Api from "./Api";
import { Link } from "react-router-dom";

const api = new Api();

export default function SSoft_Case_Studies() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [text, setText] = useState([]);
  const [widgetId, setWidgetId] = useState();
  const [article, setArticle] = useState([]);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res.data) {
            const apiSectionData = res.data.results;
            setSections(apiSectionData);
            if (apiSectionData?.[0]?.widgets?.[1]?.id) {
              setWidgetId(apiSectionData[0].widgets[1].id);
            }
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };
    getSectionDetail();
  }, [activeLanguage]);

  const getArticleDetail = useCallback(() => {
    const api = new GlobalApi();
    api
      .getArticleDetailByYearDescendingPagination(widgetId, 85, 2, "", "", "")
      .then((res) => {
        setArticle(res.data.results);
      });
  }, [widgetId]);

  useEffect(() => {
    if (widgetId) {
      getArticleDetail();
    }
  }, [widgetId]);

  useEffect(() => {
    let switchCaseCompleted = 0;
    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0:
              setText(section?.widget_contents[0]?.article_language);
              break;

            default:
              break;
          }
          switchCaseCompleted++;
        });
        if (switchCaseCompleted === 4) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  return (
    <div className="w-full relative md:pt-[100px] pt-[20px] bg-gradient-to-t from-white via-gray-50/50 to-newDarkBlue/10">
      <div className="section-container section-margin-x">
        <h1 className="header-style-non-hero  text-center mb-4">
          {text?.title}
        </h1>
        <p className="subheader-style-non-hero max-w-4xl mx-auto text-center">
          {PARSE(text?.content || "")}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 mdl:gap-[4rem] gap-8 mt-[4rem]">
          {article?.map((item, index) => {
            const articleUrl = `${text?.path}/${item?.id}/${item?.article_languages?.slug_title}`;
            return (
              <div
                key={index}
                className="bg-white mdl:p-[40px] p-6  shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200"
              >
                <h2 className="content-header-style-non-hero !leading-[150%] !font-inter-bold  mb-4">
                  {item?.article_languages?.title}
                </h2>
                <div className="content-subheader-style-non-hero prose-lg prose-strong:!font-[600] line-clamp-[8]">
                  {PARSE(item?.article_languages?.content || "")}
                </div>
                <Link
                  to={articleUrl || "/"}
                  className="content-subheader-style-non-hero-non-prose text-newDarkBlue  space-x-[10px] flex items-center mt-4"
                >
                  <span className=""> {text?.summary}</span> <VscArrowRight />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
